import React from "react";
import {
  ModalOverlay,
  ModalContainer,
  ModalContent,
  ModalIcon,
  ModalTitle,
  ModalMessage,
  ModalButton,
} from "./Modal.styled";

const Modal = ({ type, title, message, onClose, onAction }) => {
  const getIcon = () => {
    switch (type) {
      case "success":
        return "✓";
      case "error":
        return "!";
      default:
        return "i";
    }
  };

  const getButtonText = () => {
    switch (type) {
      case "success":
        return "Continue";
      case "error":
        // Only show "Try Again" if there's a custom action (e.g., for calculated column errors)
        // Otherwise show "OK" for generic errors
        return onAction ? "Try Again" : "OK";
      default:
        return "OK";
    }
  };

  const handleButtonClick = () => {
    // If onAction is provided, use it (for "Try Again"), otherwise use onClose
    if (onAction) {
      onAction();
    } else {
      onClose();
    }
  };

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        <ModalContent>
          <ModalIcon type={type}>{getIcon()}</ModalIcon>
          <ModalTitle>{title}</ModalTitle>
          <ModalMessage>{message.replace(/^Error: /, "")}</ModalMessage>
          <ModalButton type={type} onClick={handleButtonClick}>
            {getButtonText()}
          </ModalButton>
        </ModalContent>
      </ModalContainer>
    </ModalOverlay>
  );
};

export default Modal;
